import makeId from "../../libs/make-id";
import {forceSetDirty, setTabAsClean, setTabAsDirty} from "../../pages/survey/questions/attach-form-dirty";
import {attachFroalaEditor, froalaSetContent} from "../../plugins/froala-editor";

export function attachMessages($context) {
    $context = $($context);
    const randomId = makeId(10);
    const messageItems = $context.find('.message-item');
    messageItems.each(function(){
        $(this).html(
            $(this).html().replaceAll('--TABS-ID--', randomId)
        );
    });
    
    // "external" events - the developer should not know the messages structure, so these events are attached to the main container
    $context.on('overwrite-message', '.message-item', function(event, message) {
            // if message is empty - clear it
            if(!message) {
                $(this).trigger('clear-message');
                return;
            }
            $(this).find('.gender-message-toggle').prop('checked', message.gender_sensitive).trigger('change');
            froalaSetContent($(this).find('.message-neutral textarea').get(0), message.gender_sensitive ? null : message.neutral);
            froalaSetContent($(this).find('.textarea-male').get(0), message.gender_sensitive ? message.male : null);
            froalaSetContent($(this).find('.textarea-female').get(0), message.gender_sensitive ? message.female : null);
        })
        .on('clear-message', '.message-item', function() {
            $(this).find('.gender-message-toggle').prop('checked', false).trigger('change');
            $(this).find('.message-neutral textarea').val('');
            $(this).find('.textarea-male').val(null);
            $(this).find('.textarea-female').val(null);
        })
        .on('set-restore-category', '.message-item', function (event, category) {
            $(this).find('.restore-defaults').data('restore-category', category);
        })
    $context.find('.messages-container')
        // listen on new event type
        .on('add-new-message', function () {
            const randomId = makeId(10);
            const sourceTemplateId = $(this).find('.add-next-message').data('source-template-id');
            const targetId = $(this).find('.add-next-message').data('target-id');

            const template = $(document.getElementById(sourceTemplateId))// because of dot notation
                .html()
                .replaceAll('--MESSAGE-ID--', randomId);
            const $template = $(template);

            $(document.getElementById(targetId)).append($template); // because of dot notation
            attachFroalaEditor();

            $(this).find('.messages-list').trigger('renumber-messages');
        })
        .on('overwrite-messages', function (event, messages) {
            const existingLength = $(this).find('.message-item').length;
            // if new list is empty, set at least one empty message
            if(messages.length === 0) {
                messages = [{gender_sensitive: false, neutral: ''}];
            }

            // if there are more new messages than the existing ones, create the missing ones
            if(messages.length > existingLength) {
                for(let i = 0; i < messages.length - existingLength; i++) {
                    $(this).trigger('add-new-message');
                }
            }
            $(this).find('.message-item').each(function (index) {
                // if the existing message is beyond the scope of new messages - delete it
                if (!(index in messages)) {
                    $(this).trigger('remove-item');
                    return;
                }
                const message = messages[index];
                $(this).trigger('overwrite-message', [message]);
            })

            if($(this).find('.message-item').length === 0) {
                $(this).trigger('add-new-message');
            }

            setTabAsClean($context.closest('.tab-pane'));
        })
        .on('set-restore-category', function (event, category) {
            $(this).find('.restore-defaults').data('restore-category', category);
        })
    ;

    $context.find('.add-next-message').on('click', function () {
        $(this).closest('.messages-container').trigger('add-new-message');
        setTabAsDirty($context.closest('.tab-pane'));
    });

    // "internal" events - attached to list container, so that new messages automatically respond to these events
    $context.find('.messages-list')
        // there is no need for the programmer to know about this event, so it is hooked up to "internal"
        .on('remove-item', '.message-item', function () {
            // list must be saved before removing element because later jQuery can't find its parent
            const $mainList = $(this).closest('.messages-list');
            // if this is the last message on the list then clear it instead of deleting it
            if($mainList.find('.message-item').length === 1) {
                $(this).trigger('clear-message');
            } else {
                $(this).remove();
            }
            $mainList.trigger('renumber-messages');
        })
        .on('click', '.message-remove', function () {
            $(this).closest('.message-item').trigger('remove-item')
            forceSetDirty($context.closest('.tab-pane'));
        })
        .on('change', '.textarea-female', function () {
            $(this).closest('.message-tabs').find('.tab-female i').addClass('hide')
        })
        .on('change', '.textarea-male', function () {
            $(this).closest('.message-tabs').find('.tab-male i').addClass('hide')
        })
        // there is no need for the programmer to know about this event, so it is hooked up to "internal"
        .on('renumber-messages', function () {
            $(this).find('.message-number').each(function (iterator) {
                $(this).text(iterator !== 0 ? iterator + 1 : '');
            });
        })
    $context
        .on('change', '.gender-message-toggle', function (e) {
            const isChecked = $(this).is(':checked');
            const $mainList = $(this).closest('.message-item');
            $mainList.find('.message-neutral').toggleClass('hide', isChecked);
            $mainList.find('.message-tabs').toggleClass('hide', !isChecked);
        })
    ;

    // renumber messages on load
    $context.find('.messages-list').trigger('renumber-messages');

    $context.on('click', '.restore-defaults', function (e) {
        e.preventDefault();
        const _this = $(this);
        const restoreMultiple = _this.data('restore-multiple');
        const category = _this.data('restore-category');
        $.ajax({
            url: _this.data('restore-url'),
            method: 'get',
            data: {category}
        }).done(function (response) {
            if(restoreMultiple) {
                _this.closest('.messages-container').trigger('overwrite-messages', [response]);
            } else {
                _this.closest('.message-item').trigger('overwrite-message', [response]);
            }
        });
        setTabAsDirty($context.closest('.tab-pane'));
    });
}
